import React from "react";
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import Layout from "../components/layout";

const placeholderSocial = {
  facebook: "#",
  twitter: "#",
  linkedin: "#",
  instagram: "#",
};

const teamMembers = [
  {
    name: "Hamood Salim Al Hashmi",
    position: "Chairman",
    description: [
      "Hamood is a results-driven and passionate entrepreneur with proven abilities to develop business ventures and converting opportunities into successes.",
      "He holds interest in several businesses in the areas of oil and gas, commodity trading, mining, and property development.",
      "He has strong interpersonal skills and a natural affinity for cultivating relationships and plays a pivotal advisory role in various international oil and gas ventures. He holds a Bachelor Degree in Business Management.",
    ],
    social: placeholderSocial,
  },
  {
    name: "David Holtom",
    position: "Vice Chairman",
    description: [
      "A highly successful leader and entrepreneur, with extensive global experience in international relations and corporate business.",
      "Possessing excellent communication skills and able to establish sustainable and profitable relationships with clients, suppliers, and stakeholders across the world.",
      "He holds interest in various companies specializing in oil and gas, aviation, and commodity trading.",
      "David was awarded the Member of the Most Excellent Order of the British Empire (MBE).",
    ],
    social: placeholderSocial,
  },
  {
    name: "Ali Izhar Ahmad",
    position: "Director / Group Chief Executive Officer",
    description: [
      "Ali Izhar is a seasoned and highly motivated individual with extensive business exposure in the oil and gas industry.",
      "He started his career as a quantity and quality surveyor in 1988. Equipped with more than 18 years of experience in the inspection business, he is an expert in the area of petroleum product specifications and requirements and was instrumental in setting up and managing a number of oil and gas trading companies.",
      "Having a complete understanding of the business, he is now entrusted to manage the day-to-day operations of the business.",
    ],
    social: placeholderSocial,
  },
  {
    name: "Terence Yuen",
    position: "Chief Operations Officer",
    description: [
      "Terence is a highly driven and passionate individual who embodies the entrepreneur spirit. He possesses 14 years of Oil Trading and Operations experience with Shell where he successfully completed various roles including Trading, Business Development and Leadership assignments. Terence holds a Bachelor's degree in Mechanical Engineering from the National University of Singapore and a Masters degree in Professional Accounting from the Singapore Management University.",
      "Terence's role as Trescorp's Chief Operations Officer is to oversee all Trading and Operation Activities for the group. His strong business acumen and expertise in relationship management will enable Trescorp to continue growing with our distinguished business partners.",
    ],
    social: placeholderSocial,
  },
  {
    name: "Wong Shin Ling",
    position: "Finance Manager",
    description: [
      "Wong Shin Ling is a highly motivated and driven finance manager with twenty-five years of commodity finance experience in top-level business banking environments. Being an experienced professional, she is equipped with the business awareness and strategic planning as well as providing financial solutions which help organizations grow financially.",
      "Having high numeracy and sound technical skills, she ensures the smooth flow of products and services delivery and keeps abreast of changes in financial regulations and legislation.",
      "Wong Shin Ling holds a degree in Bachelor of Business in Business Administration from the National University of Singapore. Her strong management skills, attention to detail, and investigative nature are bringing productive changes to the business.",
    ],
    social: placeholderSocial,
  },
  {
    name: "Saif Al Amri",
    position: "LNG Director",
    description: [
      "Saif Al Amri is results-oriented and self-motivated with more than 22 years of extensive experience in the LNG industry with Oman LNG.",
      "Saif began his career as an engineer in 1997 immediately after completing his Bachelor's degree in Mechanical Engineering from the University of Leeds in the UK. He specializes in the commercial aspects of the LNG market.",
      "Saif has a proven track record of Strategies Conception and Implementation, Long Term Contracts Negotiation, Business Development, Origination, and Optimization.",
      "Saif's role as TRESCORP's LNG Director is to establish and develop the LNG business so that Trescorp achieves its vision of becoming the LNG preferred partner of choice.",
    ],
    social: placeholderSocial,
  },
  {
    name: "Kim Jong Bum",
    position: "Head of Trading",
    description: [
      "Jong Bum (JB) Kim is a highly driven and passionate leader who embodies the elite energy trading spirit. He possesses more than 20 years of extensive experience in the oil trading sector spanning over a decade at Hyundai Oilbank followed by Shell. Throughout his career, he has successfully completed various core roles, ranging from commercial trading to leadership assignments.",
      "JB holds a Bachelor of Arts degree in English Literature from Seoul National University, combining a strong analytical foundation with excellent communication skills.",
      "In his role as Head of Trading, JB manages global energy market strategies and oversees the group's trading and operational activities. Utilizing his deep commercial insight, market experience, and collaborative approach to relationship management, he focuses on optimizing the group's business operations and fostering reliable partnerships to support steady, long-term growth.",
    ],
    social: placeholderSocial,
  },
];

const socialLinks = [
  { key: "facebook", label: "Facebook", icon: FaFacebook, className: "hover:text-blue-600" },
  { key: "twitter", label: "Twitter", icon: FaTwitter, className: "hover:text-blue-400" },
  { key: "linkedin", label: "LinkedIn", icon: FaLinkedin, className: "hover:text-blue-700" },
  { key: "instagram", label: "Instagram", icon: FaInstagram, className: "hover:text-pink-600" },
];

const hasSocialUrl = (url) => Boolean(url);

const SocialLinks = ({ social }) => {
  const links = socialLinks.filter(({ key }) => hasSocialUrl(social?.[key]));

  if (!links.length) {
    return null;
  }

  return (
    <div className="flex space-x-4 mt-4">
      {links.map(({ key, label, icon: Icon, className }) => (
        <a
          key={key}
          href={social[key]}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className={`text-gray-600 ${className}`}
        >
          <Icon size={24} />
        </a>
      ))}
    </div>
  );
};

const Team = () => {
  return (
    <Layout>
      <main>
        <div className="overflow-hidden">
          <section
            className="container mx-auto max-w-none text-gray-600 body-font md:my-auto relative bg-black"
            aria-labelledby="team-page-title"
          >
            <div className="absolute inset-0 bg-gray-800 opacity-70">
              <div
                className="w-full h-full bg-cover bg-center"
                style={{ backgroundImage: "url('../img/2968.jpg')" }}
              />
            </div>
            <div className="relative flex flex-wrap -m-4 mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
              <div className="my-20 sm:my-5 md:my-20">
                <h1
                  id="team-page-title"
                  className="ekit-heading__shadow-text2 text-white transition-all duration-300 inline-block font-bold text-4xl md:text-6xl lg:text-7xl"
                >
                  Our Management
                </h1>
              </div>
            </div>
          </section>
          <section className="container text-gray-600 body-font mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-40 md:my-20">
            <div className="flex flex-wrap -m-4 mt-10">
              {teamMembers.map((member) => (
                <article
                  key={member.name}
                  className="w-full bg-white p-6 md:p-8 rounded-lg shadow-lg transform transition-transform hover:scale-105 mb-4"
                >
                  <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2 hover:text-yellow-500 transition-colors">
                    {member.name}
                  </h2>
                  <h3
                    className="text-lg md:text-xl font-semibold text-yellow-600 mb-6 pb-4 border-b-2 border-gray-200"
                    style={{ color: "rgb(237 181 1)", borderBottom: "1px solid #e5e6ea" }}
                  >
                    {member.position}
                  </h3>
                  <div className="space-y-4 leading-relaxed text-base">
                    {member.description.map((paragraph) => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                  </div>
                  <SocialLinks social={member.social} />
                </article>
              ))}
            </div>
          </section>
        </div>
      </main>
    </Layout>
  );
};

export default Team;
